module.exports = __webpack_public_path__ + "img/Xiang_Jun_Lu-502x500.e8ecb885.jpg";